(() => {
  const initKeychainPacks = (scope = document) => {
    scope.querySelectorAll('[data-asc-keychain-pack]').forEach((widget) => {
      if (widget.dataset.ascReady === 'true') return;
      const productId = widget.dataset.productId;
      const sectionId = widget.dataset.sectionId;
      const picker = Array.from(document.querySelectorAll('variant-picker[data-product-handle="porte-cles-kawaii-mon-emotion-du-jour"]'))
        .find((candidate) => candidate.dataset.productId === productId && candidate.dataset.sectionId === sectionId);
      if (!picker) return;
      widget.dataset.ascReady = 'true';
      const controls = widget.querySelector('[data-asc-pack-controls]');
      const fields = Array.from(widget.querySelectorAll('[data-asc-pack-field]'));
      const summaries = Array.from(widget.querySelectorAll('[data-asc-pack-summary]'));
      const formatValue = () => {
        const chosenRadio = picker.querySelector('input[data-option-name="Format"]:checked');
        const chosenSelect = picker.querySelector('select[name="options[Format]"]');
        return chosenRadio?.value || chosenSelect?.value || 'À l’unité';
      };
      const updatePreview = (field) => {
        const select = field.querySelector('select');
        const preview = field.querySelector('[data-asc-emotion-preview]');
        const image = field.querySelector('[data-asc-emotion-image]');
        const name = field.querySelector('[data-asc-emotion-name]');
        const option = select?.selectedOptions?.[0];
        const source = option?.dataset.image;
        if (!source) {
          preview.hidden = true;
          image.removeAttribute('src');
          image.alt = '';
          name.textContent = '';
          return;
        }
        image.src = source;
        image.alt = option.dataset.imageAlt || option.textContent.trim();
        name.textContent = option.textContent.trim();
        preview.hidden = false;
      };
      const update = () => {
        const format = formatValue();
        const count = format === 'Lot de 3' ? 3 : format === 'Lot de 2' ? 2 : 1;
        controls.hidden = count === 1;
        fields.forEach((field) => {
          const number = Number(field.dataset.ascPackField);
          const active = count >= number;
          const select = field.querySelector('select');
          field.hidden = !active;
          select.disabled = !active;
          select.required = active;
          if (!active) {
            select.value = '';
            updatePreview(field);
          }
        });
        summaries.forEach((summary) => {
          summary.hidden = summary.dataset.ascPackSummary !== format;
        });
      };
      picker.addEventListener('change', update);
      fields.forEach((field) => field.querySelector('select')?.addEventListener('change', () => updatePreview(field)));
      update();
    });
  };
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => initKeychainPacks(), { once: true });
  } else {
    initKeychainPacks();
  }
  document.addEventListener('shopify:section:load', (event) => initKeychainPacks(event.target));
})();